import React, { useEffect, useMemo, useState } from "react";
import { X } from "lucide-react";

export default function NavbarScroll({
  items,
  activeCode,
  onSelect,
  loading,
  path,
  setPath,
}) {
  const rootChildren = useMemo(() => items?.children || [], [items]);


  useEffect(() => {
    // root change -> reset
    setPath?.([]);
  }, [rootChildren, setPath]);

  const getVisibleItems = useMemo(() => {
    // path chain follow karke current node find karo
    let current = rootChildren;
    let node = null;

    for (const label of path || []) {
      node = current?.find((n) => n?.label === label);
      current = node?.children || [];
    }
    return current?.length ? current : rootChildren;
  }, [rootChildren, path]);

  const handleClick = (child) => {
    onSelect?.(child);

    // ✅ path me add only if it has children (so breadcrumb chain build ho)
    if (child?.children?.length) {
      setPath?.((prev) => [...(prev || []), child.label]);
    }
  };

  const popLast = () => setPath?.((prev) => (prev?.length ? prev.slice(0, -1) : []));

  if (loading) return null;
  
  if (!rootChildren?.length) return null;

  return (
  <div className="px-2 md:px-6 lg:px-11">

  <div className="
    relative flex items-center gap-3 mt-4
    overflow-x-auto whitespace-nowrap
    rounded-2xl
    bg-white/60 backdrop-blur-md
    border border-orange-200
    shadow-sm
    px-2 md:px-5 py-3
    scrollbar-hide
  ">

    

    {/* ✅ Breadcrumb chips */}
    {(path || []).map((label, idx) => (
      <button
        key={`${label}-${idx}`}
        type="button"
        onClick={() => setPath?.((prev) => prev.slice(0, idx + 1))}
        className="
          shrink-0 px-2 md:px-5 py-2 md:py-2.5
            rounded-full
            text-[12px] md:text-sm font-semibold
          bg-gradient-to-r from-orange-500 to-orange-600
          text-white
          shadow-md
          hover:scale-105
          transition-all duration-200
        "
      >
        {label}
      </button>
    ))}

    {/* Back Button */}
    {(path || []).length > 0 && (
      <button
        type="button"
        onClick={popLast}
        className="
          shrink-0 p-2.5
          rounded-full
          bg-white
          border border-gray-200
          text-gray-600
          shadow-sm
          hover:bg-orange-50 hover:text-orange-600
          transition-all duration-200
        "
        title="Go one level up"
      >
        <X size={16} />
      </button>
    )}

    {/* ✅ Current level */}
    {getVisibleItems?.map((child) => {
      const active = child?.code === activeCode;

      return (
        <button
          key={`${child?.code}-${child?.label}`}
          type="button"
          onClick={() => handleClick(child)}
          className={`
            shrink-0 px-2 md:px-5 py-2 md:py-2.5
            rounded-full
            text-[12px] md:text-sm font-medium
            transition-all duration-200
            border
            ${
              active
                ? "bg-gradient-to-r from-orange-500 to-orange-600 text-white shadow-md border-orange-500 md:scale-105"
                : "bg-orange-50 text-orange-700 border-orange-200 hover:bg-orange-200 hover:shadow-sm"
            }
          `}
        >
          {child.label}
          {child?.children?.length ? (
            <span className="ml-1 opacity-60">›</span>
          ) : null}
        </button>
      );
    })}
  </div>
</div>
  );
}